import { Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMobileForbiddenPracticesContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
}));

export const StyledMobileForbiddenPracticesLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: 1.5,
  '&:hover': {
    opacity: 0.8,
  },
}));
